export enum AttivitaSvoltaEnum {
  AGRICOLTURA_SILVICULTURA_E_PESCA = 'Agricoltura, silvicultura e pesca',
  ESTRAZIONE_DI_MINERALI_DA_CAVE_E_MINIERE = 'Estrazione di minerali da cave e miniere',
  MANIFATTURA = 'Manifattura',
  PETROLIO = 'Petrolio',
  INDUSTRIA = 'Industria',
  COMMERCIO_E_O_PRODUZIONE_ARMI_DIFESA = 'Commercio e/o produzione armi, difesa',
  METALLI_PREZIOSI = 'Metalli preziosi',
  PRODUZIONE_DI_ENERGIA_ELETTRICA = 'Produzione di energia elettrica',
  FORNITURA_DI_ENERGIA_ELETTRICA_GAS_VAPORE_E_ARIA_CONDIZIONATA = 'Fornitura di energia elettrica, gas, vapore e aria condizionata',
  FORNITURA_DI_ACQUA_RETI_FOGNARIE = 'Fornitura di acqua, reti fognarie',
  RACCOLTA_E_SMALTIMENTO_DI_RIFIUTI = 'Raccolta e smaltimento di rifiuti',
  COSTRUZIONE_E_RISTRUTTURAZIONI_EDILIZIE = 'Costruzione e ristrutturazioni edilizie',
  COMMERCIO_E_RIPARAZIONE_DI_AUTOVEICOLI_E_MOTOCICLI = 'Commercio e riparazione di autoveicoli e motocicli',
  COMMERCIO_VARI = 'Commercio vario',
  COMPRO_ORO = 'Compro oro',
  COMMERCIO_DI_OPERE_D_ARTE = "Commercio di opere d'arte",
  TRASPORTI_E_MAGAZZINAGGIO = 'Trasporti e magazzinaggio',
  SERVIZI_DI_ALLOGGIO_E_DI_RISTORAZIONE = 'Servizi di alloggio e di ristorazione',
  SERVIZI_DI_INFORMAZIONE_E_COMUNICAZIONE = 'Servizi di informazione e comunicazione',
  ATTIVITA_FINANZIARIE_E_ASSICURATIVE = 'Attività finanziarie e assicurative',
  CAMBIO_VALUTE = 'Cambio valute',
  AGENTI_IN_ATTIVITA_FINANZIARIA_E_SOGGETTI_CONVENZIONATI = 'Agenti in attività finanziaria e soggetti convenzionati',
  ATTIVITA_DELLE_SOCIETA_FIDUCIARIE = 'Attività delle società fiduciarie',
  MONEY_TRANSFER = 'Money transfer',
  IMMOBILIARI = 'Immobiliari',
  PROFESSIONALI_SCIENTIFICHE_E_TECNICHE = 'Professionali, scientifiche e tecniche',
  NOLEGGIO_AGENZIE_DI_VIAGGIO_SERVIZI_DI_SUPPORTO_ALLE_IMPRESE = 'Noleggio, agenzie di viaggio, servizi di supporto alle imprese',
  TRASPORTO_VALORI = 'Trasporto valori',
  PUBBLICA_AMMINISTRAZIONE = 'Pubblica Amministrazione',
  ISTRUZIONE = 'Istruzione',
  SANITA = 'Sanità',
  ASSISTENZA_SOCIALE = 'Assistenza sociale',
  ARTISTICHE_SPORTIVE_DI_INTRATTENIMENTO_E_DIVERTIMENTO = 'Artistiche, sportive, di intrattenimento e divertimento',
  GIOCHI_E_SCOMMESSE = 'Giochi e scommesse',
  ALTRE_ATTIVITA_DI_SERVIZI = 'Altre attività di servizi',
  FAMIGLIE_E_CONVIVENZE = 'Famiglie e convivenze',
  ORGANIZZAZIONE_ED_ORGANISMI_EXTRATERRITORIALI = 'Organizzazione ed organismi extraterritoriali',
  HOLDING = 'Holding',
}
